// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Finterfaces%2Fsrc%2Fworkflow-definition-base.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { ActivationTier, BillingDomain, DlpPolicyScope, InputStage, PrefilterActionType, PrefilterType, ProducerWaitPolicy, RequestedContextCardinality, TriggerCondition, UnitType, WorkflowKind, WorkflowVisibility } from '../../workflow-definition-base';
import { authTokenTypeValidatorInstance, userDataBoundaryTypeValidatorInstance, userTypeValidatorInstance } from '../../generated/validator/authTypes-validator.g';
import { serializationProfileValidatorInstance } from '../../generated/validator/serialization-profile-validator.g';
import { workflowModelOptionsValidatorInstance } from '../../generated/validator/workflow-model-validator.g';
import { workflowModelItemSchemaValidatorInstance } from '../../generated/validator/workflow-model-schema-validator.g';
import { validateArray, validateDictionary } from '@augloop/validator-common';
export class AuthTokenOptionsValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AuthTokenOptions: Expected object, got undefined object for AuthTokenOptionsValidator' };
        }
        if (obj.type === undefined) {
            return { success: false, error: 'AuthTokenOptions: Required field "type" is missing' };
        }
        else {
            const result = authTokenTypeValidatorInstance.validate(obj.type);
            if (!result.success) {
                result.error = "AuthTokenOptions.type: " + result.error;
                return result;
            }
        }
        if (obj.scopes !== undefined) {
            const result = validateArray(obj.scopes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "AuthTokenOptions.scopes: " + result.error;
                return result;
            }
        }
        if ((obj.userType !== undefined)) {
            const result = userTypeValidatorInstance.validate(obj.userType);
            if (!result.success) {
                result.error = "AuthTokenOptions.userType: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const authTokenOptionsValidatorInstance = new AuthTokenOptionsValidator();
export class WorkflowDefinitionBaseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowDefinitionBase: Expected object, got undefined object for WorkflowDefinitionBaseValidator' };
        }
        if (obj.id === undefined) {
            return { success: false, error: 'WorkflowDefinitionBase: Required field "id" is missing' };
        }
        else if (typeof obj.id !== 'string') {
            return { success: false, error: 'WorkflowDefinitionBase: Required field "id" is wrong type' };
        }
        if (obj.kind === undefined) {
            return { success: false, error: 'WorkflowDefinitionBase: Required field "kind" is missing' };
        }
        else {
            const result = workflowKindValidatorInstance.validate(obj.kind);
            if (!result.success) {
                result.error = "WorkflowDefinitionBase.kind: " + result.error;
                return result;
            }
        }
        if ((obj.visibility !== undefined)) {
            const result = workflowVisibilityValidatorInstance.validate(obj.visibility);
            if (!result.success) {
                result.error = "WorkflowDefinitionBase.visibility: " + result.error;
                return result;
            }
        }
        if ((obj.collectionScopeType !== undefined) && (typeof obj.collectionScopeType !== 'string')) {
            return { success: false, error: 'WorkflowDefinitionBase: Optional field "collectionScopeType" is wrong type' };
        }
        if (obj.inputTypes === undefined) {
            return { success: false, error: 'WorkflowDefinitionBase: Required field "inputTypes" is missing' };
        }
        else {
            const result = validateArray(obj.inputTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "WorkflowDefinitionBase.inputTypes: " + result.error;
                return result;
            }
        }
        if (obj.outputTypes === undefined) {
            return { success: false, error: 'WorkflowDefinitionBase: Required field "outputTypes" is missing' };
        }
        else {
            const result = validateArray(obj.outputTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "WorkflowDefinitionBase.outputTypes: " + result.error;
                return result;
            }
        }
        if (obj.correlatedSignals !== undefined) {
            const result = validateArray(obj.correlatedSignals, 1, undefined, 'string');
            if (!result.success) {
                result.error = "WorkflowDefinitionBase.correlatedSignals: " + result.error;
                return result;
            }
        }
        if (obj.requiredTokenTypes !== undefined) {
            const result = validateArray(obj.requiredTokenTypes, 1, authTokenTypeValidatorInstance, '{AuthTokenType}');
            if (!result.success) {
                result.error = "WorkflowDefinitionBase.requiredTokenTypes: " + result.error;
                return result;
            }
        }
        if (obj.requiredTokenOptions !== undefined) {
            const result = validateArray(obj.requiredTokenOptions, 1, authTokenOptionsValidatorInstance, '{AuthTokenOptions}');
            if (!result.success) {
                result.error = "WorkflowDefinitionBase.requiredTokenOptions: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const workflowDefinitionBaseValidatorInstance = new WorkflowDefinitionBaseValidator();
export class ActivationConfigValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ActivationConfig: Expected object, got undefined object for ActivationConfigValidator' };
        }
        if (obj.clientAppName === undefined) {
            return { success: false, error: 'ActivationConfig: Required field "clientAppName" is missing' };
        }
        else if (typeof obj.clientAppName !== 'string') {
            return { success: false, error: 'ActivationConfig: Required field "clientAppName" is wrong type' };
        }
        if (obj.clientAppPlatform === undefined) {
            return { success: false, error: 'ActivationConfig: Required field "clientAppPlatform" is missing' };
        }
        else if (typeof obj.clientAppPlatform !== 'string') {
            return { success: false, error: 'ActivationConfig: Required field "clientAppPlatform" is wrong type' };
        }
        if ((obj.clientReleaseAudienceGroup !== undefined) && (typeof obj.clientReleaseAudienceGroup !== 'string')) {
            return { success: false, error: 'ActivationConfig: Optional field "clientReleaseAudienceGroup" is wrong type' };
        }
        if ((obj.clientTenantGroup !== undefined) && (typeof obj.clientTenantGroup !== 'string')) {
            return { success: false, error: 'ActivationConfig: Optional field "clientTenantGroup" is wrong type' };
        }
        if (obj.activationTier === undefined) {
            return { success: false, error: 'ActivationConfig: Required field "activationTier" is missing' };
        }
        else {
            const result = activationTierValidatorInstance.validate(obj.activationTier);
            if (!result.success) {
                result.error = "ActivationConfig.activationTier: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const activationConfigValidatorInstance = new ActivationConfigValidator();
export class ActivationFlightsConfigValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ActivationFlightsConfig: Expected object, got undefined object for ActivationFlightsConfigValidator' };
        }
        if (obj.clientAppName === undefined) {
            return { success: false, error: 'ActivationFlightsConfig: Required field "clientAppName" is missing' };
        }
        else if (typeof obj.clientAppName !== 'string') {
            return { success: false, error: 'ActivationFlightsConfig: Required field "clientAppName" is wrong type' };
        }
        if (obj.requiredFlights === undefined) {
            return { success: false, error: 'ActivationFlightsConfig: Required field "requiredFlights" is missing' };
        }
        else {
            const result = validateArray(obj.requiredFlights, 1, undefined, 'string');
            if (!result.success) {
                result.error = "ActivationFlightsConfig.requiredFlights: " + result.error;
                return result;
            }
        }
        if (obj.restrictedFlights !== undefined) {
            const result = validateArray(obj.restrictedFlights, 1, undefined, 'string');
            if (!result.success) {
                result.error = "ActivationFlightsConfig.restrictedFlights: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const activationFlightsConfigValidatorInstance = new ActivationFlightsConfigValidator();
export class ActivationUserConfigValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ActivationUserConfig: Expected object, got undefined object for ActivationUserConfigValidator' };
        }
        if ((obj.userType !== undefined)) {
            const result = userTypeValidatorInstance.validate(obj.userType);
            if (!result.success) {
                result.error = "ActivationUserConfig.userType: " + result.error;
                return result;
            }
        }
        if ((obj.tenantId !== undefined) && (typeof obj.tenantId !== 'string')) {
            return { success: false, error: 'ActivationUserConfig: Optional field "tenantId" is wrong type' };
        }
        return { success: true };
    }
}
export const activationUserConfigValidatorInstance = new ActivationUserConfigValidator();
export class RequestedContextTypesRuleValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'RequestedContextTypesRule: Expected object, got undefined object for RequestedContextTypesRuleValidator' };
        }
        if (obj.contextTypes === undefined) {
            return { success: false, error: 'RequestedContextTypesRule: Required field "contextTypes" is missing' };
        }
        else {
            const result = validateArray(obj.contextTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "RequestedContextTypesRule.contextTypes: " + result.error;
                return result;
            }
        }
        if (obj.cardinality === undefined) {
            return { success: false, error: 'RequestedContextTypesRule: Required field "cardinality" is missing' };
        }
        else {
            const result = requestedContextCardinalityValidatorInstance.validate(obj.cardinality);
            if (!result.success) {
                result.error = "RequestedContextTypesRule.cardinality: " + result.error;
                return result;
            }
        }
        if (obj.activationConditions !== undefined) {
            const result = validateArray(obj.activationConditions, 1, activationFlightsConfigValidatorInstance, '{ActivationFlightsConfig}');
            if (!result.success) {
                result.error = "RequestedContextTypesRule.activationConditions: " + result.error;
                return result;
            }
        }
        if ((obj.shouldTriggerOnContextChange !== undefined) && (typeof obj.shouldTriggerOnContextChange !== 'boolean')) {
            return { success: false, error: 'RequestedContextTypesRule: Optional field "shouldTriggerOnContextChange" is wrong type' };
        }
        if ((obj.producerWaitPolicy !== undefined)) {
            const result = producerWaitPolicyValidatorInstance.validate(obj.producerWaitPolicy);
            if (!result.success) {
                result.error = "RequestedContextTypesRule.producerWaitPolicy: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const requestedContextTypesRuleValidatorInstance = new RequestedContextTypesRuleValidator();
export class DynamicExecutionPreferencesValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'DynamicExecutionPreferences: Expected object, got undefined object for DynamicExecutionPreferencesValidator' };
        }
        if (obj.inputSizeUnit === undefined) {
            return { success: false, error: 'DynamicExecutionPreferences: Required field "inputSizeUnit" is missing' };
        }
        else {
            const result = unitTypeValidatorInstance.validate(obj.inputSizeUnit);
            if (!result.success) {
                result.error = "DynamicExecutionPreferences.inputSizeUnit: " + result.error;
                return result;
            }
        }
        if (obj.inputSize === undefined) {
            return { success: false, error: 'DynamicExecutionPreferences: Required field "inputSize" is missing' };
        }
        else if (typeof obj.inputSize !== 'number') {
            return { success: false, error: 'DynamicExecutionPreferences: Required field "inputSize" is wrong type' };
        }
        if ((obj.contextUnit !== undefined)) {
            const result = unitTypeValidatorInstance.validate(obj.contextUnit);
            if (!result.success) {
                result.error = "DynamicExecutionPreferences.contextUnit: " + result.error;
                return result;
            }
        }
        if ((obj.contextAbove !== undefined) && (typeof obj.contextAbove !== 'number')) {
            return { success: false, error: 'DynamicExecutionPreferences: Optional field "contextAbove" is wrong type' };
        }
        if ((obj.contextBelow !== undefined) && (typeof obj.contextBelow !== 'number')) {
            return { success: false, error: 'DynamicExecutionPreferences: Optional field "contextBelow" is wrong type' };
        }
        return { success: true };
    }
}
export const dynamicExecutionPreferencesValidatorInstance = new DynamicExecutionPreferencesValidator();
export class PrefilterActionDefinitionValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'PrefilterActionDefinition: Expected object, got undefined object for PrefilterActionDefinitionValidator' };
        }
        if (obj.type === undefined) {
            return { success: false, error: 'PrefilterActionDefinition: Required field "type" is missing' };
        }
        else {
            const result = prefilterActionTypeValidatorInstance.validate(obj.type);
            if (!result.success) {
                result.error = "PrefilterActionDefinition.type: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const prefilterActionDefinitionValidatorInstance = new PrefilterActionDefinitionValidator();
export class PrefilterDefinitionValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'PrefilterDefinition: Expected object, got undefined object for PrefilterDefinitionValidator' };
        }
        if (obj.type === undefined) {
            return { success: false, error: 'PrefilterDefinition: Required field "type" is missing' };
        }
        else {
            const result = prefilterTypeValidatorInstance.validate(obj.type);
            if (!result.success) {
                result.error = "PrefilterDefinition.type: " + result.error;
                return result;
            }
        }
        if ((obj.action !== undefined)) {
            const result = prefilterActionDefinitionValidatorInstance.validate(obj.action);
            if (!result.success) {
                result.error = "PrefilterDefinition.action: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const prefilterDefinitionValidatorInstance = new PrefilterDefinitionValidator();
export class EventSequenceOptionsValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'EventSequenceOptions: Expected object, got undefined object for EventSequenceOptionsValidator' };
        }
        if ((obj.minWindowSize !== undefined) && (typeof obj.minWindowSize !== 'number')) {
            return { success: false, error: 'EventSequenceOptions: Optional field "minWindowSize" is wrong type' };
        }
        if ((obj.maxWindowSize !== undefined) && (typeof obj.maxWindowSize !== 'number')) {
            return { success: false, error: 'EventSequenceOptions: Optional field "maxWindowSize" is wrong type' };
        }
        if ((obj.windowIncrement !== undefined) && (typeof obj.windowIncrement !== 'number')) {
            return { success: false, error: 'EventSequenceOptions: Optional field "windowIncrement" is wrong type' };
        }
        if ((obj.minTimeFrame !== undefined) && (typeof obj.minTimeFrame !== 'number')) {
            return { success: false, error: 'EventSequenceOptions: Optional field "minTimeFrame" is wrong type' };
        }
        if ((obj.maxEventAge !== undefined) && (typeof obj.maxEventAge !== 'number')) {
            return { success: false, error: 'EventSequenceOptions: Optional field "maxEventAge" is wrong type' };
        }
        if ((obj.minTimeIncrement !== undefined) && (typeof obj.minTimeIncrement !== 'number')) {
            return { success: false, error: 'EventSequenceOptions: Optional field "minTimeIncrement" is wrong type' };
        }
        if (obj.includedTypes !== undefined) {
            const result = validateArray(obj.includedTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "EventSequenceOptions.includedTypes: " + result.error;
                return result;
            }
        }
        if (obj.excludedTypes !== undefined) {
            const result = validateArray(obj.excludedTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "EventSequenceOptions.excludedTypes: " + result.error;
                return result;
            }
        }
        if (obj.required === undefined) {
            return { success: false, error: 'EventSequenceOptions: Required field "required" is missing' };
        }
        else if (typeof obj.required !== 'boolean') {
            return { success: false, error: 'EventSequenceOptions: Required field "required" is wrong type' };
        }
        if ((obj.shouldTriggerWorkflow !== undefined) && (typeof obj.shouldTriggerWorkflow !== 'boolean')) {
            return { success: false, error: 'EventSequenceOptions: Optional field "shouldTriggerWorkflow" is wrong type' };
        }
        return { success: true };
    }
}
export const eventSequenceOptionsValidatorInstance = new EventSequenceOptionsValidator();
export class WorkflowDefinitionValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowDefinition: Expected object, got undefined object for WorkflowDefinitionValidator' };
        }
        if ((obj.resourceId !== undefined) && (typeof obj.resourceId !== 'string')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "resourceId" is wrong type' };
        }
        if ((obj.priority !== undefined) && (typeof obj.priority !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "priority" is wrong type' };
        }
        if (obj.activationConfigs !== undefined) {
            const result = validateArray(obj.activationConfigs, 1, activationConfigValidatorInstance, '{ActivationConfig}');
            if (!result.success) {
                result.error = "WorkflowDefinition.activationConfigs: " + result.error;
                return result;
            }
        }
        if (obj.invalidationTypes !== undefined) {
            const result = validateArray(obj.invalidationTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "WorkflowDefinition.invalidationTypes: " + result.error;
                return result;
            }
        }
        if (obj.requestedContextTypesRules !== undefined) {
            const result = validateArray(obj.requestedContextTypesRules, 1, requestedContextTypesRuleValidatorInstance, '{RequestedContextTypesRule}');
            if (!result.success) {
                result.error = "WorkflowDefinition.requestedContextTypesRules: " + result.error;
                return result;
            }
        }
        if ((obj.inputStage !== undefined)) {
            const result = inputStageValidatorInstance.validate(obj.inputStage);
            if (!result.success) {
                result.error = "WorkflowDefinition.inputStage: " + result.error;
                return result;
            }
        }
        if (obj.triggerSignals !== undefined) {
            const result = validateArray(obj.triggerSignals, 1, undefined, 'string');
            if (!result.success) {
                result.error = "WorkflowDefinition.triggerSignals: " + result.error;
                return result;
            }
        }
        if ((obj.triggerSignalsOptions !== undefined)) {
            const result = triggerSignalsOptionsValidatorInstance.validate(obj.triggerSignalsOptions);
            if (!result.success) {
                result.error = "WorkflowDefinition.triggerSignalsOptions: " + result.error;
                return result;
            }
        }
        if (obj.triggerConditions !== undefined) {
            const result = validateArray(obj.triggerConditions, 1, triggerConditionValidatorInstance, '{TriggerCondition}');
            if (!result.success) {
                result.error = "WorkflowDefinition.triggerConditions: " + result.error;
                return result;
            }
        }
        if (obj.optionalTokenTypes !== undefined) {
            const result = validateArray(obj.optionalTokenTypes, 1, authTokenTypeValidatorInstance, '{AuthTokenType}');
            if (!result.success) {
                result.error = "WorkflowDefinition.optionalTokenTypes: " + result.error;
                return result;
            }
        }
        if (obj.optionalTokenOptions !== undefined) {
            const result = validateArray(obj.optionalTokenOptions, 1, authTokenOptionsValidatorInstance, '{AuthTokenOptions}');
            if (!result.success) {
                result.error = "WorkflowDefinition.optionalTokenOptions: " + result.error;
                return result;
            }
        }
        if (obj.activationFlightsConfigs !== undefined) {
            const result = validateArray(obj.activationFlightsConfigs, 1, activationFlightsConfigValidatorInstance, '{ActivationFlightsConfig}');
            if (!result.success) {
                result.error = "WorkflowDefinition.activationFlightsConfigs: " + result.error;
                return result;
            }
        }
        if (obj.activationUserConfigs !== undefined) {
            const result = validateArray(obj.activationUserConfigs, 1, activationUserConfigValidatorInstance, '{ActivationUserConfig}');
            if (!result.success) {
                result.error = "WorkflowDefinition.activationUserConfigs: " + result.error;
                return result;
            }
        }
        if ((obj.isAppOnlyTokenAllowed !== undefined) && (typeof obj.isAppOnlyTokenAllowed !== 'boolean')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "isAppOnlyTokenAllowed" is wrong type' };
        }
        if ((obj.minDelayMs !== undefined) && (typeof obj.minDelayMs !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "minDelayMs" is wrong type' };
        }
        if ((obj.maxDelayMs !== undefined) && (typeof obj.maxDelayMs !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "maxDelayMs" is wrong type' };
        }
        if ((obj.maxExecutionTimeInS !== undefined) && (typeof obj.maxExecutionTimeInS !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "maxExecutionTimeInS" is wrong type' };
        }
        if ((obj.maxQueueWaitTimeMs !== undefined) && (typeof obj.maxQueueWaitTimeMs !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "maxQueueWaitTimeMs" is wrong type' };
        }
        if ((obj.maxAnnotations !== undefined) && (typeof obj.maxAnnotations !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "maxAnnotations" is wrong type' };
        }
        if ((obj.serializationProfile !== undefined)) {
            const result = serializationProfileValidatorInstance.validate(obj.serializationProfile);
            if (!result.success) {
                result.error = "WorkflowDefinition.serializationProfile: " + result.error;
                return result;
            }
        }
        if ((obj.isStateful !== undefined) && (typeof obj.isStateful !== 'boolean')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "isStateful" is wrong type' };
        }
        if ((obj.maxBatchSize !== undefined) && (typeof obj.maxBatchSize !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "maxBatchSize" is wrong type' };
        }
        if ((obj.stateExpiryMs !== undefined) && (typeof obj.stateExpiryMs !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "stateExpiryMs" is wrong type' };
        }
        if ((obj.bypassModel !== undefined) && (typeof obj.bypassModel !== 'boolean')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "bypassModel" is wrong type' };
        }
        if (obj.bypassTypes !== undefined) {
            const result = validateArray(obj.bypassTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "WorkflowDefinition.bypassTypes: " + result.error;
                return result;
            }
        }
        if ((obj.annotatesSubtree !== undefined) && (typeof obj.annotatesSubtree !== 'boolean')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "annotatesSubtree" is wrong type' };
        }
        if ((obj.rowsBefore !== undefined) && (typeof obj.rowsBefore !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "rowsBefore" is wrong type' };
        }
        if ((obj.rowsAfter !== undefined) && (typeof obj.rowsAfter !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "rowsAfter" is wrong type' };
        }
        if ((obj.columnsBefore !== undefined) && (typeof obj.columnsBefore !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "columnsBefore" is wrong type' };
        }
        if ((obj.columnsAfter !== undefined) && (typeof obj.columnsAfter !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "columnsAfter" is wrong type' };
        }
        if ((obj.isFullWorksheetRequired !== undefined) && (typeof obj.isFullWorksheetRequired !== 'boolean')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "isFullWorksheetRequired" is wrong type' };
        }
        if ((obj.isFullTableColumnsRequired !== undefined) && (typeof obj.isFullTableColumnsRequired !== 'boolean')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "isFullTableColumnsRequired" is wrong type' };
        }
        if ((obj.dynamicExecutionPreferences !== undefined)) {
            const result = dynamicExecutionPreferencesValidatorInstance.validate(obj.dynamicExecutionPreferences);
            if (!result.success) {
                result.error = "WorkflowDefinition.dynamicExecutionPreferences: " + result.error;
                return result;
            }
        }
        if ((obj.fetchExistingAnnotations !== undefined) && (typeof obj.fetchExistingAnnotations !== 'boolean')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "fetchExistingAnnotations" is wrong type' };
        }
        if ((obj.modelOptions !== undefined)) {
            const result = workflowModelOptionsValidatorInstance.validate(obj.modelOptions);
            if (!result.success) {
                result.error = "WorkflowDefinition.modelOptions: " + result.error;
                return result;
            }
        }
        if (obj.modelSchema !== undefined) {
            const result = validateArray(obj.modelSchema, 1, workflowModelItemSchemaValidatorInstance, '{WorkflowModelItemSchema}');
            if (!result.success) {
                result.error = "WorkflowDefinition.modelSchema: " + result.error;
                return result;
            }
        }
        if ((obj.skipWorkflowItemSequencing !== undefined) && (typeof obj.skipWorkflowItemSequencing !== 'boolean')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "skipWorkflowItemSequencing" is wrong type' };
        }
        if (obj.deltaTypesByInputType !== undefined) {
            const result = validateDictionary(obj.deltaTypesByInputType, 1, undefined, 'string');
            if (!result.success) {
                result.error = "WorkflowDefinition.deltaTypesByInputType: " + result.error;
                return result;
            }
        }
        if ((obj.allowDefinitionOverride !== undefined) && (typeof obj.allowDefinitionOverride !== 'boolean')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "allowDefinitionOverride" is wrong type' };
        }
        if (obj.definitionOverrideTargetWorkflows !== undefined) {
            const result = validateArray(obj.definitionOverrideTargetWorkflows, 1, undefined, 'string');
            if (!result.success) {
                result.error = "WorkflowDefinition.definitionOverrideTargetWorkflows: " + result.error;
                return result;
            }
        }
        if (obj.prefilters !== undefined) {
            const result = validateArray(obj.prefilters, 1, prefilterDefinitionValidatorInstance, '{PrefilterDefinition}');
            if (!result.success) {
                result.error = "WorkflowDefinition.prefilters: " + result.error;
                return result;
            }
        }
        if ((obj.eventSequenceOptions !== undefined)) {
            const result = eventSequenceOptionsValidatorInstance.validate(obj.eventSequenceOptions);
            if (!result.success) {
                result.error = "WorkflowDefinition.eventSequenceOptions: " + result.error;
                return result;
            }
        }
        if ((obj.maxSynchronizationWaitTimeMs !== undefined) && (typeof obj.maxSynchronizationWaitTimeMs !== 'number')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "maxSynchronizationWaitTimeMs" is wrong type' };
        }
        if ((obj.billingDomain !== undefined)) {
            const result = billingDomainValidatorInstance.validate(obj.billingDomain);
            if (!result.success) {
                result.error = "WorkflowDefinition.billingDomain: " + result.error;
                return result;
            }
        }
        if ((obj.synchronizationConfig !== undefined)) {
            const result = synchronizationConfigValidatorInstance.validate(obj.synchronizationConfig);
            if (!result.success) {
                result.error = "WorkflowDefinition.synchronizationConfig: " + result.error;
                return result;
            }
        }
        if (obj.dlpPolicyScopes !== undefined) {
            const result = validateArray(obj.dlpPolicyScopes, 1, dlpPolicyScopeValidatorInstance, '{DlpPolicyScope}');
            if (!result.success) {
                result.error = "WorkflowDefinition.dlpPolicyScopes: " + result.error;
                return result;
            }
        }
        if (obj.id === undefined) {
            return { success: false, error: 'WorkflowDefinition: Required field "id" is missing' };
        }
        else if (typeof obj.id !== 'string') {
            return { success: false, error: 'WorkflowDefinition: Required field "id" is wrong type' };
        }
        if (obj.kind === undefined) {
            return { success: false, error: 'WorkflowDefinition: Required field "kind" is missing' };
        }
        else {
            const result = workflowKindValidatorInstance.validate(obj.kind);
            if (!result.success) {
                result.error = "WorkflowDefinition.kind: " + result.error;
                return result;
            }
        }
        if ((obj.visibility !== undefined)) {
            const result = workflowVisibilityValidatorInstance.validate(obj.visibility);
            if (!result.success) {
                result.error = "WorkflowDefinition.visibility: " + result.error;
                return result;
            }
        }
        if ((obj.collectionScopeType !== undefined) && (typeof obj.collectionScopeType !== 'string')) {
            return { success: false, error: 'WorkflowDefinition: Optional field "collectionScopeType" is wrong type' };
        }
        if (obj.inputTypes === undefined) {
            return { success: false, error: 'WorkflowDefinition: Required field "inputTypes" is missing' };
        }
        else {
            const result = validateArray(obj.inputTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "WorkflowDefinition.inputTypes: " + result.error;
                return result;
            }
        }
        if (obj.outputTypes === undefined) {
            return { success: false, error: 'WorkflowDefinition: Required field "outputTypes" is missing' };
        }
        else {
            const result = validateArray(obj.outputTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "WorkflowDefinition.outputTypes: " + result.error;
                return result;
            }
        }
        if (obj.correlatedSignals !== undefined) {
            const result = validateArray(obj.correlatedSignals, 1, undefined, 'string');
            if (!result.success) {
                result.error = "WorkflowDefinition.correlatedSignals: " + result.error;
                return result;
            }
        }
        if (obj.requiredTokenTypes !== undefined) {
            const result = validateArray(obj.requiredTokenTypes, 1, authTokenTypeValidatorInstance, '{AuthTokenType}');
            if (!result.success) {
                result.error = "WorkflowDefinition.requiredTokenTypes: " + result.error;
                return result;
            }
        }
        if (obj.requiredTokenOptions !== undefined) {
            const result = validateArray(obj.requiredTokenOptions, 1, authTokenOptionsValidatorInstance, '{AuthTokenOptions}');
            if (!result.success) {
                result.error = "WorkflowDefinition.requiredTokenOptions: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const workflowDefinitionValidatorInstance = new WorkflowDefinitionValidator();
export class UserContextValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'UserContext: Expected object, got undefined object for UserContextValidator' };
        }
        if ((obj.oid !== undefined) && (typeof obj.oid !== 'string')) {
            return { success: false, error: 'UserContext: Optional field "oid" is wrong type' };
        }
        if ((obj.tid !== undefined) && (typeof obj.tid !== 'string')) {
            return { success: false, error: 'UserContext: Optional field "tid" is wrong type' };
        }
        if ((obj.puid !== undefined) && (typeof obj.puid !== 'string')) {
            return { success: false, error: 'UserContext: Optional field "puid" is wrong type' };
        }
        if ((obj.username !== undefined) && (typeof obj.username !== 'string')) {
            return { success: false, error: 'UserContext: Optional field "username" is wrong type' };
        }
        if ((obj.userType !== undefined)) {
            const result = userTypeValidatorInstance.validate(obj.userType);
            if (!result.success) {
                result.error = "UserContext.userType: " + result.error;
                return result;
            }
        }
        if ((obj.clientIpAddress !== undefined) && (typeof obj.clientIpAddress !== 'string')) {
            return { success: false, error: 'UserContext: Optional field "clientIpAddress" is wrong type' };
        }
        if ((obj.userDataBoundaryType !== undefined)) {
            const result = userDataBoundaryTypeValidatorInstance.validate(obj.userDataBoundaryType);
            if (!result.success) {
                result.error = "UserContext.userDataBoundaryType: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const userContextValidatorInstance = new UserContextValidator();
export class TriggerSignalsOptionsValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'TriggerSignalsOptions: Expected object, got undefined object for TriggerSignalsOptionsValidator' };
        }
        if ((obj.triggerImmediately !== undefined) && (typeof obj.triggerImmediately !== 'boolean')) {
            return { success: false, error: 'TriggerSignalsOptions: Optional field "triggerImmediately" is wrong type' };
        }
        return { success: true };
    }
}
export const triggerSignalsOptionsValidatorInstance = new TriggerSignalsOptionsValidator();
export class SynchronizationConfigValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SynchronizationConfig: Expected object, got undefined object for SynchronizationConfigValidator' };
        }
        if (obj.shouldSkipSynchronization === undefined) {
            return { success: false, error: 'SynchronizationConfig: Required field "shouldSkipSynchronization" is missing' };
        }
        else if (typeof obj.shouldSkipSynchronization !== 'boolean') {
            return { success: false, error: 'SynchronizationConfig: Required field "shouldSkipSynchronization" is wrong type' };
        }
        return { success: true };
    }
}
export const synchronizationConfigValidatorInstance = new SynchronizationConfigValidator();
export class WorkflowKindValidator {
    validate(value) {
        if (!WorkflowKindValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "WorkflowKind"' };
        }
        return { success: true };
    }
}
WorkflowKindValidator.validValues = new Set([WorkflowKind.SingleItem, WorkflowKind.Reduce, WorkflowKind.Grid, WorkflowKind.DynamicText, WorkflowKind.Join, WorkflowKind.Generic]);
export const workflowKindValidatorInstance = new WorkflowKindValidator();
export class BillingDomainValidator {
    validate(value) {
        if (!BillingDomainValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "BillingDomain"' };
        }
        return { success: true };
    }
}
BillingDomainValidator.validValues = new Set([BillingDomain.Default, BillingDomain.Copilot]);
export const billingDomainValidatorInstance = new BillingDomainValidator();
export class DlpPolicyScopeValidator {
    validate(value) {
        if (!DlpPolicyScopeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "DlpPolicyScope"' };
        }
        return { success: true };
    }
}
DlpPolicyScopeValidator.validValues = new Set([DlpPolicyScope.None, DlpPolicyScope.ContentFiltering_M365Copilot]);
export const dlpPolicyScopeValidatorInstance = new DlpPolicyScopeValidator();
export class WorkflowVisibilityValidator {
    validate(value) {
        if (!WorkflowVisibilityValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "WorkflowVisibility"' };
        }
        return { success: true };
    }
}
WorkflowVisibilityValidator.validValues = new Set([WorkflowVisibility.Default, WorkflowVisibility.LocalOnly, WorkflowVisibility.Exclusive]);
export const workflowVisibilityValidatorInstance = new WorkflowVisibilityValidator();
export class ActivationTierValidator {
    validate(value) {
        if (!ActivationTierValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "ActivationTier"' };
        }
        return { success: true };
    }
}
ActivationTierValidator.validValues = new Set([ActivationTier.PreActivate, ActivationTier.Default, ActivationTier.DelayActivate, ActivationTier.NeverActivate]);
export const activationTierValidatorInstance = new ActivationTierValidator();
export class RequestedContextCardinalityValidator {
    validate(value) {
        if (!RequestedContextCardinalityValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "RequestedContextCardinality"' };
        }
        return { success: true };
    }
}
RequestedContextCardinalityValidator.validValues = new Set([RequestedContextCardinality.Required, RequestedContextCardinality.Optional]);
export const requestedContextCardinalityValidatorInstance = new RequestedContextCardinalityValidator();
export class ProducerWaitPolicyValidator {
    validate(value) {
        if (!ProducerWaitPolicyValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "ProducerWaitPolicy"' };
        }
        return { success: true };
    }
}
ProducerWaitPolicyValidator.validValues = new Set([ProducerWaitPolicy.Never, ProducerWaitPolicy.Always]);
export const producerWaitPolicyValidatorInstance = new ProducerWaitPolicyValidator();
export class InputStageValidator {
    validate(value) {
        if (!InputStageValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "InputStage"' };
        }
        return { success: true };
    }
}
InputStageValidator.validValues = new Set([InputStage.PreSeed, InputStage.OnSeed, InputStage.PostSeed, InputStage.All]);
export const inputStageValidatorInstance = new InputStageValidator();
export class TriggerConditionValidator {
    validate(value) {
        if (!TriggerConditionValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "TriggerCondition"' };
        }
        return { success: true };
    }
}
TriggerConditionValidator.validValues = new Set([TriggerCondition.UpstreamWorkflowsReady, TriggerCondition.AnnotationMetadataUpdated, TriggerCondition.DeltaUpdate, TriggerCondition.NonExclusiveTriggerSignals]);
export const triggerConditionValidatorInstance = new TriggerConditionValidator();
export class UnitTypeValidator {
    validate(value) {
        if (!UnitTypeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "UnitType"' };
        }
        return { success: true };
    }
}
UnitTypeValidator.validValues = new Set([UnitType.Character, UnitType.Paragraph]);
export const unitTypeValidatorInstance = new UnitTypeValidator();
export class PrefilterTypeValidator {
    validate(value) {
        if (!PrefilterTypeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "PrefilterType"' };
        }
        return { success: true };
    }
}
PrefilterTypeValidator.validValues = new Set([PrefilterType.Input, PrefilterType.Delta, PrefilterType.UILanguage, PrefilterType.MaxInputCount, PrefilterType.ExtensionLimits]);
export const prefilterTypeValidatorInstance = new PrefilterTypeValidator();
export class PrefilterActionTypeValidator {
    validate(value) {
        if (!PrefilterActionTypeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "PrefilterActionType"' };
        }
        return { success: true };
    }
}
PrefilterActionTypeValidator.validValues = new Set([PrefilterActionType.SetPredefinedAnnotation, PrefilterActionType.ClearAnnotations]);
export const prefilterActionTypeValidatorInstance = new PrefilterActionTypeValidator();
//# sourceMappingURL=workflow-definition-base-validator.g.js.map